import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=06c8c6a0&lang=less&scoped=true"

import exportComponent from "D:\\Change\\MyGit\\Close\\public\\02_don't_need_to_update\\Navigation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c8c6a0"]])

export default __exports__